import { apiClient } from "../api/apiClient.js";

// Thin fetch wrappers over the real Agent Contact write endpoints
// (BackofficeController.CreateAgentContact/DeleteAgentContact -
// BackofficeHierarchyService.CreateAgentContactAsync/SoftDeleteAgentContactAsync).
// These routes already existed before Prompt 138 - reading contacts has
// always come back on GET /backoffice/agents/{agentId}/profile
// (useOwningAgentProfile.js), this file only adds the two matching writes
// so the Agent Portal Contacts page is a real CRUD screen, not just a
// read-only mirror of the profile response.

export function createAgentContact(agentId, { contactType, contactValue, isPrimary } = {}) {
  if (!agentId) {
    throw new Error("createAgentContact requires an agentId");
  }
  return apiClient.post(`/backoffice/agents/${encodeURIComponent(agentId)}/contacts`, {
    contactType,
    contactValue,
    isPrimary: Boolean(isPrimary),
  });
}

export function deleteAgentContact(agentId, contactId) {
  if (!agentId || !contactId) {
    throw new Error("deleteAgentContact requires an agentId and a contactId");
  }
  return apiClient.delete(`/backoffice/agents/${encodeURIComponent(agentId)}/contacts/${encodeURIComponent(contactId)}`);
}
